module.exports = __webpack_public_path__ + "img/guide-background.32d9876e.jpg";